import { setMwValue, getMwValue, setMwToken, getMwToken } from './utils';
import { API_URL } from './application';


const INVOICE_SAVE_POST_URL = API_URL+'api/Invoices/UpdateInvoice'
const INVOICE_SAVE_POST_ADMIN_URL = API_URL+'api/Invoices/UpdateInvoiceAdmin'

const INVOICE_CREATE_POST_URL = API_URL+'api/Invoices'

const COMPANYINVOICES_GET_URL = API_URL+'api/Companies/GetInvoicesByCompany?CompanyId='
const INVOICE_GET_URL = API_URL+'api/Invoices/'
export const REQUEST_COMPANY_INVOICES = 'REQUEST_COMPANY_INVOICES'
export const RECEIVE_COMPANY_INVOICES_SUCCESS = 'RECEIVE_COMPANY_INVOICES_SUCCESS'
export const RECEIVE_COMPANY_INVOICES_ERROR = 'RECEIVE_COMPANY_INVOICES_ERROR'

export const REQUEST_INVOICE_SAVE = 'REQUEST_INVOICE_SAVE'
export const RECEIVE_INVOICE_SAVE_SUCCESS = 'RECEIVE_INVOICE_SAVE_SUCCESS'
export const RECEIVE_INVOICE_SAVE_ERROR = 'RECEIVE_INVOICE_SAVE_ERROR'

export const REQUEST_INVOICE = 'REQUEST_INVOICE'
export const RECEIVE_INVOICE_SUCCESS = 'RECEIVE_INVOICE_SUCCESS'
export const RECEIVE_INVOICE_ERROR = 'RECEIVE_INVOICE_ERROR'


export const REQUEST_INVOICE_CREATE = 'REQUEST_INVOICE_CREATE'
export const RECEIVE_INVOICE_CREATE_SUCCESS = 'RECEIVE_INVOICE_CREATE_SUCCESS'
export const RECEIVE_INVOICE_CREATE_ERROR = 'RECEIVE_INVOICE_CREATE_ERROR'

export function getFetchInvoicesByCompanyId(companyid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_COMPANY_INVOICES});        
         return fetch(COMPANYINVOICES_GET_URL+companyid, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_COMPANY_INVOICES_SUCCESS, items: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchInvoiceById(id) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE});        
         return fetch(INVOICE_GET_URL+id, 
            { headers: {           
                'authorization' : 'bearer '+token
            }                       
         }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_INVOICE_SUCCESS, item: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}



export function createInvoiceAdmin(invoice) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE_CREATE, invoice: invoice});        
         return fetch(INVOICE_CREATE_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoice
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_INVOICE_CREATE_SUCCESS, item: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function updateInvoiceAdmin(invoice) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_INVOICE_SAVE, invoice: invoice});        
         return fetch(INVOICE_SAVE_POST_ADMIN_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...invoice
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_INVOICE_SAVE_SUCCESS, item: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}
